/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderDto } from './ProviderDto';
import {
    ProviderDtoFromJSON,
    ProviderDtoFromJSONTyped,
    ProviderDtoToJSON,
    ProviderDtoToJSONTyped,
} from './ProviderDto';
import type { PrescriptionOrderSummaryDto } from './PrescriptionOrderSummaryDto';
import {
    PrescriptionOrderSummaryDtoFromJSON,
    PrescriptionOrderSummaryDtoFromJSONTyped,
    PrescriptionOrderSummaryDtoToJSON,
    PrescriptionOrderSummaryDtoToJSONTyped,
} from './PrescriptionOrderSummaryDto';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';
import type { PatientDto } from './PatientDto';
import {
    PatientDtoFromJSON,
    PatientDtoFromJSONTyped,
    PatientDtoToJSON,
    PatientDtoToJSONTyped,
} from './PatientDto';

/**
 * 
 * @export
 * @interface PrescriptionDto
 */
export interface PrescriptionDto {
    /**
     * Prescription ID
     * @type {string}
     * @memberof PrescriptionDto
     */
    id: string;
    /**
     * Patient ID (Firebase UID)
     * @type {string}
     * @memberof PrescriptionDto
     */
    patientId: string;
    /**
     * Provider ID (Firebase UID)
     * @type {string}
     * @memberof PrescriptionDto
     */
    providerId: string;
    /**
     * Status
     * @type {string}
     * @memberof PrescriptionDto
     */
    status: string;
    /**
     * Created at
     * @type {Date}
     * @memberof PrescriptionDto
     */
    createdAt: Date;
    /**
     * Updated at
     * @type {Date}
     * @memberof PrescriptionDto
     */
    updatedAt: Date;
    /**
     * Patient
     * @type {PatientDto}
     * @memberof PrescriptionDto
     */
    patient: PatientDto;
    /**
     * Provider
     * @type {ProviderDto}
     * @memberof PrescriptionDto
     */
    provider: ProviderDto;
    /**
     * Price in USD
     * @type {string}
     * @memberof PrescriptionDto
     */
    price: string;
    /**
     * Canceled by
     * @type {UserDto}
     * @memberof PrescriptionDto
     */
    cancelBy: UserDto;
    /**
     * Orders associated with this prescription
     * @type {Array<PrescriptionOrderSummaryDto>}
     * @memberof PrescriptionDto
     */
    orders?: Array<PrescriptionOrderSummaryDto>;
}

/**
 * Check if a given object implements the PrescriptionDto interface.
 */
export function instanceOfPrescriptionDto(value: object): value is PrescriptionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('providerId' in value) || value['providerId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('patient' in value) || value['patient'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('cancelBy' in value) || value['cancelBy'] === undefined) return false;
    return true;
}

export function PrescriptionDtoFromJSON(json: any): PrescriptionDto {
    return PrescriptionDtoFromJSONTyped(json, false);
}

export function PrescriptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrescriptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'providerId': json['providerId'],
        'status': json['status'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'patient': PatientDtoFromJSON(json['patient']),
        'provider': ProviderDtoFromJSON(json['provider']),
        'price': json['price'],
        'cancelBy': UserDtoFromJSON(json['cancelBy']),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(PrescriptionOrderSummaryDtoFromJSON)),
    };
}

export function PrescriptionDtoToJSON(json: any): PrescriptionDto {
    return PrescriptionDtoToJSONTyped(json, false);
}

export function PrescriptionDtoToJSONTyped(value?: PrescriptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'providerId': value['providerId'],
        'status': value['status'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'patient': PatientDtoToJSON(value['patient']),
        'provider': ProviderDtoToJSON(value['provider']),
        'price': value['price'],
        'cancelBy': UserDtoToJSON(value['cancelBy']),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(PrescriptionOrderSummaryDtoToJSON)),
    };
}

